import React from 'react';
import BaseLineSeries from './private/BaseLineSeries';
export default function LineSeries(props) {
  return /*#__PURE__*/React.createElement(BaseLineSeries, props);
}